// PrivateRoute.js

import React from "react";
import { Navigate } from "react-router-dom";
import Layout from "../Layout";

// Define a custom hook to check authentication
const useAuth = () => {
  const userData = localStorage.getItem("user"); // You can adjust the key as per your setup
  return userData;
};

const PrivateRoutes = ({ children, component: Component, ...rest }) => {
  const userData = useAuth();
  // If authenticated, render the provided component
  return userData ? (
    <Layout />
  ) : (
    <Navigate to={`${process.env.PUBLIC_URL}/login`} />
  );
};

export default PrivateRoutes;
